import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/detailsToggle/styles.scss';export default {
  "detailsToggle": "_detailsToggle_vqcck_1",
  "label": "_label_vqcck_12"
};